import template from 'text!./LocationTable.html';

export default [() => ({
    restrict: 'E',
    scope: {
        schedule: '&'
    },
    template: template
})];